import styled from 'styled-components';
import AlertIcon from '@spectrum-icons/workflow/Alert';

export const AlertFormat = styled.p`
  position: relative;
  margin: 0 0 1em 0;
  padding: 5px;
  border: 1px solid #d4440d;
  background-color: #ffff80;
  border-color: #e5a500;
  color: #cc7600;
  display: flex;
  align-items: center;
  width: fit-content;
  font-size: 12px;
`;

interface AlertProps {
  children: React.ReactNode;
  className?: string;
  iconSize?: 'S' | 'XXS' | 'XS' | 'M' | 'L' | 'XL' | 'XXL';
  marginEnd?: number;
}

export const Alert = (props: AlertProps) => {
  const { className, children, iconSize = 'S', marginEnd = 5 } = props;

  return (
    <AlertFormat className={className}>
      <AlertIcon
        size={iconSize}
        marginEnd={marginEnd}
        aria-label="Alert"
        color="notice"
      />
      {children}
    </AlertFormat>
  );
};
